module.exports = __webpack_public_path__ + "static/media/new_person_icon.88973685.svg";